import type { MouseEvent, ReactNode } from "react";

import { Button, classNames } from "@alpacahq/ui/old";

const FIXED_ON_BOTTOM_CLASSES = [
  "fixed",
  "z-10",
  "bottom-0",
  "left-0",
  "right-0",
  "border-t",
  "border-gray-300",
  "mx-auto",
  "bg-gray-50",
];

const FIXED_ON_BOTTOM = classNames(FIXED_ON_BOTTOM_CLASSES.join(" "));
const FIXED_ON_BOTTOM_MOBILE = classNames(
  FIXED_ON_BOTTOM_CLASSES.map((cls) => `max-sm:${cls}`).join(" "),
);

type ButtonProps = {
  label?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  loading?: boolean;
  type?: "button" | "submit";
};

interface FixedBottomMenuProps {
  aboveButtons?: ReactNode;
  back?: ButtonProps;
  next?: ButtonProps;
  className?: string;
  fixedOnBottom?: boolean;
}

export const FixedBottomMenu = ({
  back,
  next,
  className,
  fixedOnBottom,
  aboveButtons,
}: FixedBottomMenuProps) => (
  <div
    className={classNames(
      "flex w-full flex-col items-center gap-4 py-2",
      FIXED_ON_BOTTOM_MOBILE,
      fixedOnBottom && FIXED_ON_BOTTOM,
      className,
    )}
  >
    {aboveButtons && (
      <div
        className={classNames(
          "mx-auto flex w-full max-w-[800px] items-center justify-between gap-4 max-sm:px-6",
          fixedOnBottom ? "px-6" : "max-sm:px-6",
        )}
      >
        {aboveButtons}
      </div>
    )}
    <div
      className={classNames(
        "mx-auto flex w-full max-w-[800px] items-center justify-between gap-4 max-sm:px-6",
        fixedOnBottom ? "px-6" : "max-sm:px-6",
        !back && "justify-end",
      )}
    >
      {back && (
        <Button
          variant="v2/stroke"
          onClick={back.onClick}
          disabled={back.disabled}
          loading={back.loading}
        >
          {back.label ?? "Back"}
        </Button>
      )}
      {next && (
        <Button
          variant="v2/filled"
          onClick={next.onClick}
          disabled={next.disabled}
          loading={next.loading}
        >
          {next.label ?? "Continue"}
        </Button>
      )}
    </div>
  </div>
);
